<template>
  <b-container fluid class="d-flex h-100">
    <b-row class="flex-fill">
      <b-col cols="3" class="no-padding-left d-flex flex-column flex-fill">
        <b-card class=" d-flex flex-column flex-fill" title="Risk nodes">
          <TreeNav ref="tree" :item="tree" @click="handleClick"></TreeNav>
        </b-card>
      </b-col>

      <b-col class="mt-2">
        <div v-if="selected === null">
          Choose a risk node on the left panel.
        </div>
        <div v-else id="summary">
          <b-card :title="selected.id">
            <b-link
              href="#"
              v-if="
                this.selected !== undefined &&
                  this.selected.nodeType === 'TRADE'
              "
              @click="$bvModal.show('bv-modal-example')"
              >See trade details</b-link
            >
            <div v-if="fetched">
              <RiskDetails :results="results" />
            </div>
            <div v-else><b-spinner label="Spinning"></b-spinner></div>
          </b-card>
        </div>

        <div>
          <b-modal size="xl" id="bv-modal-example" hide-footer>
            <template v-slot:modal-title>
              {{ selected !== null ? selected.id : "" }}
            </template>

            <template v-if="selected !== null">
              <TradeDetails :swapId="selected.id" />
            </template>

            <b-button class="mt-3" @click="$bvModal.hide('bv-modal-example')"
              >Close Me</b-button
            >
          </b-modal>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import TradeDetails from "@/components/TradeDetails.vue";
import RiskDetails from "@/components/RiskDetails.vue";
// Nodetree has some redundant structure.
function buildTree(nodeTree) {
  let children = [];
  if (nodeTree.children !== undefined) {
    children = nodeTree.children.map(node => buildTree(node));
  }
  return {
    id: nodeTree.data.id,
    selected: false,
    nodeType: nodeTree.data.nodeType,
    children: children
  };
}

function getNodeById(tree, nodeId) {
  if (tree.id == nodeId) {
    return {
      id: nodeId,
      nodeType: tree.nodeType
    };
  }

  for (var child of tree.children) {
    let maybenode = getNodeById(child, nodeId);
    if (maybenode != null) {
      return maybenode;
    }
  }

  return null;
}

export default {
  data() {
    return {
      fields: [{ key: "pnlValue", sortable: true }],
      selected: null,
      tree: {},
      results: { pv: 0.0, im: 0.0, sensitivities: [], pnlVector: [] },
      fetched: false
    };
  },
  components: { TradeDetails, RiskDetails },
  async mounted() {
    let nodes = await this.$client.getRiskNodes();
    this.tree = buildTree(nodes);
    this.scatterData[0].x = await this.$client.getScenarioInfo();
  },
  methods: {
    async handleClick(itemId) {
      this.selected = getNodeById(this.tree, itemId);
      this.results = { pv: 0.0, im: 0.0, sensitivities: [], pnlVector: [] };
      this.fetched = false;
      await this.computeRisk();
    },
    async computeRisk() {
      if (this.selected != null) {
        let results = await this.$client.computeRisk(this.selected);
        this.results = results;
        this.results.initialMargin = -this.results.initialMargin;
        this.fetched = true;
      }
    }
  },
  computed: {
    detailLink() {
      // only for swaps.
      return `/trade/${this.selected.id}`;
    }
  }
};
</script>

<style scoped>
.left-nav {
  height: 100%;
}

.flex-fill {
  flex: 1;
}
.no-padding-left {
  padding-left: 0%;
}
</style>
